
@if (_showPopupSelector) {
  <kendo-window
    style="z-index:20"
    [title]="title"
    (close)="onCloseWindow(true)"
    class="addFromLibraryPopup">
    <div class="greytabtop">
      <button kendoButton
        class="topRightButtonSelect"
        (click)="onReturnSelectedItem($event)">
        Select & Return
      </button>
    </div>
    <asap-grid-layout
      [selectable]="true"
      [singleSelect]="singleSelection"
      [groupingEnabled]="true"
      [pagingEnabled]="true"
      [headerEnable]="true"
      [headerTitle]="title"
      [entityName]="_entity"
      [addNewFormEnabled]="false"
      [orderEnable]="true"
      [page]="_pageName"
      [deletedEnabled]="false"
      [sortingEnabled]="true"
      [selectByField]="'id'"
      [_assetPurchaseOrderStatusValue]="_assetPurchaseOrderStatusValue"
      [selectByFieldTitle]="title"
      [enableSiteSelection]="false"
      [filteringEnable]="true"
      [resolver]="_resolver"
      [HideNotesFields]="HideNotesFields"
      (onRowSelectionChanges)="onRowSelectionChanges($event)"
      (onRowObjectSelectionChanges)="onRowObjectSelectionChanges($event)">
      @for (column of _gridFields; track column) {
        @if (column.selected) {
          @if (!column.isTemplate) {
            <ng-template
              pageListColumn
              [field]="column.field"
              [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
              [type]="column.type"
              let-item>
              @if (column.type == 'date') {
                {{ item[column.field] | dateFormat }}
              }
              @if (column.type != 'date') {
                {{column.field | complexFieldValue: item}}
              }
              @if (column.isCustomField == true) {
                {{item[column.field]}}
              }
            </ng-template>
          }
          @if (column.isTemplate) {
            <ng-template
              pageListColumn
              [field]="column.field"
              [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
              [type]="column.type"
              let-item>
              @if (column.type == 'date') {
                {{ item[column.field] | dateFormat }}
              }
              @if (column.type != 'date') {
                {{column.field | complexFieldValue: item}}
              }
              @if (column.isCustomField == true) {
                {{item[column.field]}}
              }
            </ng-template>
          }
        }
      }
    </asap-grid-layout>
  </kendo-window>
}
